function navigatePath(businessType: any) {
  const path: any = {
    "JOB-23": "/SCRC060110",
    "JOB-28": "/SCRC060013",
    "JOB-29": "/SCRC060013",
    "JOB-31": "/SCRC060026",
    "JOB-32": "/SCRC060026",
    "JOB-33": "/SCRC060028",
  };

  return path[businessType] ?? "/error";
}

export { navigatePath };
